module.exports = __webpack_public_path__ + "img/rank_bg.16fb68ab.png";